import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePermissionCheck} from "../../../components/protectedContent";
import {requestIOTypes} from "../../../redux/Actions/controllers.actions";
import {getSelectedController} from "../../../redux/Selectors/controllers.selectors";

export const useGetIoTypes = () => {
  const dispatch = useDispatch();
  const canViewInventorySensors = usePermissionCheck(["view_inventorysensors"]);

  const selectedController = useSelector(getSelectedController);
  const {properties = {}} = selectedController;
  const {appliance_type = ""} = properties;

  const [ioTypes, setIOTypes] = useState([]);

  useEffect(() => {
    if (canViewInventorySensors && appliance_type !== "Loki0") {
      dispatch(requestIOTypes(setIOTypes));
    }
  }, [appliance_type, canViewInventorySensors, dispatch]);

  return {ioTypes, appliance_type};
};
